"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = exports.default = (0, _runtime.IconWrapper)('mistake_normal', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("style", ['.kd-stroke-width-icon-regular{stroke-width:var(--kd-stroke-width-icon-regular, 1px); }.kd-color-icon-white{fill:#FFFFFF; fill:var(--kd-color-icon-white, #FFFFFF); stroke:#FFFFFF; stroke:var(--kd-color-icon-white, #FFFFFF); }.kd-color-icon-error{fill:#DD3332; fill:var(--kd-color-icon-error, #DD3332); stroke:#DD3332; stroke:var(--kd-color-icon-error, #DD3332); }']), h("g", {
    "class": "kd-color-icon-error kd-stroke-width-icon-regular"
  }, [h("path", {
    "attrs": {
      "d": "M16 7.99973C16 12.418 12.4183 15.9997 8 15.9997C3.58172 15.9997 0 12.418 0 7.99973C0 3.58145 3.58172 -0.000274658 8 -0.000274658C12.4183 -0.000274658 16 3.58145 16 7.99973Z",
      "stroke": "none"
    }
  })]), h("g", {
    "class": "kd-color-icon-white kd-stroke-width-icon-regular"
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.76666 5.96835C4.43472 5.6364 4.43471 5.09821 4.76666 4.76627C5.0986 4.43432 5.63679 4.43432 5.96874 4.76626L7.99998 6.79748L10.0312 4.76626C10.3632 4.43432 10.9014 4.43432 11.2333 4.76627C11.5652 5.09821 11.5652 5.6364 11.2333 5.96835L9.20207 7.99955L11.2332 10.0307C11.5651 10.3626 11.5651 10.9008 11.2332 11.2327C10.9013 11.5647 10.3631 11.5647 10.0311 11.2327L7.99998 9.20162L5.96884 11.2327C5.63689 11.5647 5.0987 11.5647 4.76676 11.2327C4.43481 10.9008 4.43482 10.3626 4.76677 10.0307L6.79789 7.99955L4.76666 5.96835Z",
      "stroke": "none"
    }
  })])]);
});